var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1872 1.47368H12.9091V1.43158C12.9091 0.631579 12.2674 0 11.4545 0H8.54545C7.73262 0 7.09091 0.631579 7.09091 1.43158V1.47368H2.81283C2.36364 1.47368 2 1.83158 2 2.27368V3.07368C2 3.51579 2.36364 3.87368 2.81283 3.87368H17.1872C17.6364 3.87368 18 3.51579 18 3.07368V2.27368C18 1.83158 17.6364 1.47368 17.1872 1.47368Z",
    fill: "#7D90B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1177 4.96841H3.88238C3.64708 4.96841 3.47596 5.15789 3.49735 5.38947L4.09628 17.5789C4.16045 18.9263 5.29414 20 6.66313 20H13.3155C14.6845 20 15.8182 18.9474 15.8824 17.5789L16.4813 5.38947C16.5241 5.17894 16.3316 4.96841 16.1177 4.96841ZM8.67382 16.7368C8.67382 17.1158 8.37435 17.4105 7.98933 17.4105C7.6043 17.4105 7.30484 17.1158 7.30484 16.7368V8.25262C7.30484 7.87368 7.6043 7.57894 7.98933 7.57894C8.37435 7.57894 8.67382 7.87368 8.67382 8.25262V16.7368ZM12.6952 16.7368C12.6952 17.1158 12.3957 17.4105 12.0107 17.4105C11.6257 17.4105 11.3262 17.1158 11.3262 16.7368V8.25262C11.3262 7.87368 11.6257 7.57894 12.0107 7.57894C12.3957 7.57894 12.6952 7.87368 12.6952 8.25262V16.7368Z",
    fill: "#7D90B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.e385b6e9268e4f7043a3202b1e78834a.svg";
export { ForwardRef as ReactComponent };